import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Badge } from '@leroy-merlin-br/backyard-react'
import {
  ChevronDoubleDownOutline,
  ChevronDoubleUpOutline
} from '@backyard-ui/icons'

import { isPickup } from 'checkout/components/MyOrders/modules/messages/shipment'

const WAITING_ORDER_PICKUP = 'Aguardando retirada'
const SEPARATION_PROBLEM = 'Problema na separação'
const DELIVERY_ATTEMPT = 'Tentativa de entrega'
const CANCELLED = 'Cancelado'

const OrderTitle = ({
  id,
  shipments,
  totalValue,
  date,
  fiscalId,
  isOpen,
  hasOrderToPay,
  payable,
  paymentUrl,
  serviceCount = 0,
  hasOrderToPickUp = false,
  hasSeparationProblem = false,
  hasDeliveryAttempt = false,
  hasCancelled = false
}) => {
  const pickupsCount = shipments.filter(shipment => isPickup(shipment.type)).length
  const shipmentCount = shipments.length - pickupsCount
  const SHIPMENT_LABEL = shipmentCount === 1 ? 'entrega' : 'entregas'
  const PICKUP_LABEL = pickupsCount === 1 ? 'retirada' : 'retiradas'
  const SERVICE_LABEL = serviceCount > 1 ? 'serviços' : 'serviço'

  const PaymentOrderButton = () => {
    if (!payable || fiscalId) {
      return (
        <div className="order-item color-default">
          <p className="info">
            O pagamento desse pedido é possível apenas na Loja física
          </p>
        </div>
      )
    }
    return (
      <div className="order-item color-default">
        <a
          className="button button-primary button-full align-center payment-button"
          onClick={e => e.stopPropagation()}
          href={paymentUrl}
        >
          {' '}
          Pagar{' '}
        </a>
      </div>
    )
  }

  const orderBadge = () => {
    if (hasOrderToPickUp) {
      return <Badge appearance="warning">{WAITING_ORDER_PICKUP}</Badge>
    }
    if (hasSeparationProblem) {
      return <Badge appearance="warning">{SEPARATION_PROBLEM}</Badge>
    }
    if (hasDeliveryAttempt) {
      return <Badge appearance="warning">{DELIVERY_ATTEMPT}</Badge>
    }
    if (hasCancelled) {
      return <Badge appearance="critical">{CANCELLED}</Badge>
    }

    return (
      <Badge appearance={isOpen ? 'info' : 'primary'} variant="subtle">
        {shipmentCount > 0 && (
          <Fragment>
            {shipmentCount} {SHIPMENT_LABEL}
          </Fragment>
        )}
        {pickupsCount > 0 && (
          <Fragment>
            {shipmentCount > 0 && serviceCount === 0 && (
              <Fragment>
                {' '}
                e
                {' '}
              </Fragment>
            )}
            {shipmentCount > 0 && serviceCount > 0 && (
              <Fragment>
                ,
                {' '}
              </Fragment>
            )}
            {pickupsCount} {PICKUP_LABEL}
          </Fragment>
        )}
        {serviceCount > 0 && (
          <Fragment>
            {' '}
            e {serviceCount} {SERVICE_LABEL}
          </Fragment>
        )}
      </Badge>
    )
  }

  const Chevron = isOpen ? ChevronDoubleUpOutline : ChevronDoubleDownOutline

  return (
    <div className="order-title" data-section={id}>
      <div className="order-item color-primary">
        <strong>Pedido {id}</strong>
      </div>
      {hasOrderToPay && <PaymentOrderButton />}
      <div className="order-item color-default">
        <div className="small">Total</div>
        <strong>
          R$ {totalValue.integers},{totalValue.decimals}
        </strong>
      </div>

      <div className="order-item color-default">
        <div className="small">Data do pedido</div>
        <strong>{date}</strong>
      </div>

      <div className="order-item">{orderBadge()}</div>

      <div className="order-item color-primary">
        <Chevron width={16} height={16} />
      </div>
    </div>
  )
}

OrderTitle.propTypes = {
  id: PropTypes.string,
  shipments: PropTypes.array,
  totalValue: PropTypes.object,
  date: PropTypes.string,
  isOpen: PropTypes.bool,
  payable: PropTypes.bool,
  paymentUrl: PropTypes.string
}

export default OrderTitle
